import React from 'react';


export default props => (
  <div style={{color: 'red', marginTop: '5px', fontSize: 10}}>{props.title}</div>
)
